import { ReportLabelInspectionArea } from '@ulysses-inc/harami_api_client'
import { getMatchingValue } from './getMatchingValue'

export type AreaDisplayValues =
  | { kind: 'matching'; matchingValue: string; extractedValue: string }
  | { kind: 'extractedOnly'; extractedValue: string }
  | { kind: 'none' }

/**
 * ラベル検査の「正解値」「読取値」の表示内容を返すヘルパー
 *
 * - matchingValue があれば → 正解値 + 読取値 を表示
 * - matchingValue はないが extractedValue があれば → 読取値のみを表示（例: バーコード read モード）
 * - どちらもなければ → 表示しない（例: pattern マッチング）
 */
export const getAreaDisplayValues = (
  area: ReportLabelInspectionArea,
): AreaDisplayValues => {
  if (area.matchingValue !== '') {
    return {
      kind: 'matching',
      matchingValue: getMatchingValue(area),
      extractedValue: area.extractedValue || '-',
    }
  }
  if (area.extractedValue) {
    return {
      kind: 'extractedOnly',
      extractedValue: area.extractedValue,
    }
  }
  return { kind: 'none' }
}
